<input
  #input
  type="number"
  [attr.inputmode]="integerOnly ? 'numeric' : 'decimal'"
  (keydown)="onKeyDown($event)"
  (blur)="onBlur()"
  [min]="min"
  [max]="max"
  [step]="step"
  [(ngModel)]="value"
  class="xpo-AgGrid-cellEditor--numeric-input"
/>
